module.exports = __webpack_public_path__ + "img/3c6d0b1.jpg";